// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3yRSu","footer":"ModalCreateQualiphyProcedure_footer__2-xee","additionData":"ModalCreateQualiphyProcedure_additionData__1C3UC"};